var React = require('react');

function CategoryWorkshop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.9,8.8v2.9L8,14.6l5.1-2.8V8.8L8,11.6L2.9,8.8z M8,1.4L0,5.8l8,4.3l6.5-3.6v5H16V5.8L8,1.4z","fill":"currentColor"}));
}

CategoryWorkshop.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = CategoryWorkshop;

CategoryWorkshop.default = CategoryWorkshop;
